<div class="chat-history-sidebar" [class.chat-history-sidebar--open]="isOpen">
  <div class="chat-history-sidebar__header">
    <span class="chat-history-sidebar__title">{{ 'KNOWLEDGE_FEATURE.CHAT_HISTORY.TITLE' | translate }}</span>
    <div class="chat-history-sidebar__actions">
      <button class="chat-history-sidebar__new-chat" (click)="onNewChat()" [title]="'KNOWLEDGE_FEATURE.CHAT_HISTORY.NEW_CHAT' | translate">
        <ion-icon name="add-outline"></ion-icon>
      </button>
      <button class="chat-history-sidebar__close" (click)="close()" [title]="'KNOWLEDGE_FEATURE.CHAT_HISTORY.CLOSE' | translate">
        <ion-icon name="close-outline"></ion-icon>
      </button>
    </div>
  </div>

  <div class="chat-history-sidebar__search">
    <ion-icon name="search-outline" class="chat-history-sidebar__search-icon"></ion-icon>
    <input type="text"
           class="chat-history-sidebar__search-input"
           [placeholder]="'KNOWLEDGE_FEATURE.CHAT_HISTORY.SEARCH_PLACEHOLDER' | translate"
           [(ngModel)]="searchText" />
  </div>

  <ul class="chat-history-sidebar__list" *ngIf="filteredChats.length > 0">
    <li class="chat-history-sidebar__item"
        *ngFor="let chat of filteredChats"
        [class.chat-history-sidebar__item--active]="chat.chatId === activeChatId"
        (click)="selectChat(chat)"
        tabindex="0"
        (keydown.enter)="selectChat(chat)">
      <span class="chat-history-sidebar__item-preview">{{ getChatPreview(chat) }}</span>
      <span class="chat-history-sidebar__item-summary"
            *ngIf="chat.summary"
            [title]="chat.summary">{{ chat.summary }}</span>
      <span class="chat-history-sidebar__item-date" *ngIf="chat.updatedAt">
        {{ chat.updatedAt | date:'dd/MM/yy HH:mm' }}
      </span>
    </li>
  </ul>

  <div class="chat-history-sidebar__empty" *ngIf="filteredChats.length === 0">
    <span>{{ 'KNOWLEDGE_FEATURE.CHAT_HISTORY.EMPTY' | translate }}</span>
  </div>
</div>
